const translations = {
  "en": {
    "Filter": "Filter"
  },
  "zh-tw": {
    "Filter": "過濾器"
  }
};

export default translations;
